export default __webpack_public_path__ + "images/45a2b1d4f64f221ce9a4b18efe444548-august_banner_tablet-2.webp";